module.exports = (s) => {
  return {
    // 选择时间范围
    start_date: {
      type: 'date-picker',
      props: {
        size: 'mini',
        type: 'daterange',
        clearable: false,
        'range-separator': '至',
        'start-placeholder': '开始日期',
        'end-placeholder': '结束日期',
        'value-format': 'yyyy-MM-dd',
        'format': 'yyyy-MM-dd',
      },
      value: [],
    },
    // 广告商
    advertisers: {
      type: 'select',
      props: {
        placeholder: '请选择广告商',
        multiple: true,
      },
      options: [],
      on: {
        'change': (val) => {
          const is_single_advertiser = val.length === 1;
          is_single_advertiser && s.getMediasList({ type: val[0], is_list: true });
          s.table_filter.advertiser_ids.hidden = !is_single_advertiser;
          s.table_filter.advertiser_ids.value = [];
        },
      },
      value: ['gdt'],
      rules: { required: true, message: '请选择广告商', trigger: 'change' },
    },
    // 组员筛选
    child_user_ids: {
      type: 'select',
      props: {
        placeholder: '请选择组员',
        multiple: true,
        filterable: true,
      },
      options: [],
      value: '',
    },
    // 投放游戏
    game_ids: {
      type: 'select-tree',
      props: {
        options: [],
        ischeckbox: true,
        'check-on-click-node': true,
        props: {
          value: 'id',
          label: 'name',
          children: 'children',
        },
        'select-props': {
          placeholder: '请选择投放游戏',
          size: 'mini',
          clearable: true,
          accordion: true,
        },
      },
      on: {
        getcheckedValue: (game_ids) => {
          s.table_filter.game_ids.value = game_ids?.length ? game_ids : null;
        },
      },
      value: null,
    },
    // 投放账号
    advertiser_ids: {
      type: 'select',
      props: {
        placeholder: '请选择投放账号',
        multiple: true,
        filterable: true,
      },
      hidden: false,
      options: [],
      value: [],
    },
    // 游戏（素材）
    material_parent_game_ids: {
      type: 'select-tree',
      props: {
        options: [],
        ischeckbox: true,
        'check-on-click-node': true,
        props: {
          value: 'id',
          label: 'name',
          children: 'children',
        },
        'select-props': {
          placeholder: '请选择游戏（素材）',
          size: 'mini',
          clearable: true,
          accordion: true,
        },
      },
      on: {
        getcheckedValue: (material_parent_game_ids) => {
          s.table_filter.material_parent_game_ids.value = material_parent_game_ids?.length ? material_parent_game_ids : null;
        },
      },
      value: null,
    },
    // 需求人
    demand_sider_ids: {
      type: 'select',
      props: {
        placeholder: '请选择需求人',
        multiple: true,
        filterable: true,
      },
      options: [],
      value: [],
    },
    // 作者
    author_ids: {
      type: 'select',
      props: {
        placeholder: '请选择作者',
        multiple: true,
        filterable: true,
      },
      options: [],
      value: [],
    },
    // 素材类别
    material_types: {
      type: 'select',
      props: {
        placeholder: '请选择素材类别',
        multiple: true,
        filterable: true,
      },
      options: [{
        label: '图片',
        value: 1,
      },
      {
        label: '视频',
        value: 2,
      },
      {
        label: '落地页',
        value: 3,
      },
      {
        label: '组图',
        value: 4,
      }],
      value: [],
    },
    // 是否原创
    is_original: {
      type: 'select',
      props: {
        placeholder: '请选择是否原创',
        multiple: false,
        filterable: true,
      },
      options: [
        {
          label: '原创',
          value: 1,
        },
        {
          label: '非原创',
          value: 0,
        },
      ],
      value: '',
    },
    // 本地素材名称
    local_material_name: {
      type: 'input',
      props: {
        placeholder: '请输入素材名称',
      },
      width: 100,
      value: '',
    },
  };
};

